declare let window: any;

export const dispatchRatEvent = (
  siteName: string,
  pageName: string,
  shopId: number,
  target?: string
) => {
  let event;
  const ratPageName = document.getElementById("ratPageName");
  if (ratPageName) {
    ratPageName.setAttribute("value", pageName);
  }
  const ratSiteSection = document.getElementById("ratSiteSection");
  if (ratSiteSection) {
    ratSiteSection.setAttribute("value", siteName);
  }

  const ratShopId = document.getElementById("ratShopId");
  if (ratShopId) {
    ratShopId.setAttribute("value", shopId.toString());
  }

  if (typeof window.Event === "function") {
    event = new Event("SINGLE_PAGE_APPLICATION_LOAD");
    document.dispatchEvent(event);
  } else {
    try {
      event = document.createEvent("Event");
      event.initEvent("SINGLE_PAGE_APPLICATION_LOAD", true, true);
      document.dispatchEvent(event);
    } catch (e) {
      console.log(e);
    }
  }

  const elems = window.RAT?.$Selector(target ?? ".shared-body")?.find(
    "[data-ratid]"
  );
  window.RAT?.bind(elems);
};

/**
 * Fire a custom RAT event with a dynamic site_section (`ssc`) and page name (`pgn`).
 *
 * The RAT SDK parses `#ratSiteSection` / `#ratPageName` into its module-scoped
 * `parameters` object only at init time (and again on
 * SINGLE_PAGE_APPLICATION_LOAD). Any later mutation of those input values is
 * ignored because `addCustomEvent({ includeInput: true })` reuses that cached
 * object, not the DOM. To override per event we pass `ssc` / `pgn` (the short
 * ids for `ratSiteSection` / `ratPageName`) directly inside `pData`. RAL
 * applies pData's `setParameters` after any cached `setParameters`, so our
 * value wins.
 *
 * When `siteName` or `pageName` are not provided, the current value of the
 * corresponding hidden input is used as the default.
 *
 * @see parameterDefinitions in rat-*.js — ratSiteSection maps to "ssc",
 *      ratPageName maps to "pgn".
 */
export const dispatchRatCustomEvent = ({
  componentId,
  siteName,
  pageName,
  eventType = "click",
}: {
  componentId: string;
  siteName?: string;
  pageName?: string;
  eventType?: string;
}) => {
  const resolvedSiteName =
    siteName ??
    (document.getElementById("ratSiteSection") as HTMLInputElement | null)
      ?.value ??
    "";

  const resolvedPageName =
    pageName ??
    (document.getElementById("ratPageName") as HTMLInputElement | null)
      ?.value ??
    "";

  window.RAT?.addCustomEvent({
    pData: {
      compid: [componentId],
      ssc: resolvedSiteName,
      pgn: resolvedPageName,
    },
    eventType,
  });
};
